import StackView from './StackView';
import StackWrap from './StackWrap';
export default StackView;
export { StackWrap };
export { default as getStackedContent } from './getStackedContent';